module.exports = __webpack_public_path__ + "img/Unidad6-2.925db225.png";